import React, { useRef, useState } from "react";
import "./TermsAndConditions.css";

const policyData = {
    overview: {
        title: "Terms of Use",
        content: [
            "Welcome to the website of sandip electronics  And Automation (\"SEA\").",
            "SEA sets these Terms of Use based on the Privacy Policy and the Legal Disclaimer placed on our site, both of which are incorporated into this Agreement by reference.",
            "PLEASE READ THESE TERMS OF USE CAREFULLY.",
        ],
    },

    acceptance: {
        title: "Acceptance of Terms",
        content: [
            "By clicking \"agree\" on this page or submitting any form on this site, you signify your agreement to these Terms of Use.",
            "If you do not agree to these Terms of Use, you may not proceed to the Inquiry or Career Form pages.",
            "We reserve the right, in our sole discretion, to change, modify, add, or delete portions of these Terms of Use at any time.",
        ],
    },

    personalInfo: {
        title: "Handling of Personal Information",
        content: [
            "In general, SEA treats the information you voluntarily provide through our forms—such as your name, contact number, email address, and professional details—as personally identifying information.",
            "Such information is administered based on our Privacy Policy and the applicable laws and regulations.",
        ],
    },

    communications: {
        title: "Use of Contact Information",
        content: [
            "We will use the email address and phone number you provide solely for the purpose of contacting you regarding your specific inquiry or job application.",
            "By clicking the \"submit\" or \"agree\" button, you have opted-in to accept these communications by your own free will and choice.",
        ],
    },

    disclosure: {
        title: "Disclosure to Third Parties",
        content: [
            "We do not disclose or provide any information you submit to third parties without your consent.",
            "We may disclose information only when necessary to respond to court orders, legal processes, or any legitimate request by authorities with which we must comply.",
        ],
    },

    retention: {
        title: "Data Retention & Storage",
        content: [
            "Unlike general service providers, we do not use your information for system maintenance or marketing.",
            "We follow a strict data deletion policy where your personal information is not stored permanently.",
            "Once your job inquiry or contact request has been successfully processed and closed, your data is removed from our active records.",
        ],
    },

    security: {
        title: "Website Security and Risks",
        content: [
            "We have taken commercially reasonable care and precautions to ensure that no viruses, key loggers, destructive trojans, or malware are present on this website.",
            "However, we cannot accept any responsibility for any loss or damage occurring from the use of this website.",
        ],
    },

    cookies: {
        title: "Cookies",
        content: [
            "Our website may use cookies to enhance your experience while using our website.",
            "Your browser is most likely set to accept cookies by default.",
            "If you prefer not to receive cookies, you can change your browser settings to refuse them, but some areas of the website may not function properly as a result.",
        ],
    },

    userObligations: {
        title: "User Responsibilities",
        content: [
            "By clicking \"agree\" on this page, you also agree to:",
        ],
        list: [
            "Provide us with true and accurate information about yourself.",
            "Not damage the properties, honor, or privacy of other users or third parties.",
            "Not damage the trust and properties of sandip electronics  And Automation (SEA).",
        ],
    },

    scope: {
        title: "Scope and Relationship to Legal Disclaimer",
        content: [
            "The scope of the rights and obligations enforced by these Terms of Use are the same as the rights and obligations enforced by the Legal Disclaimer.",
            "These rights and obligations apply to parties in a legally recognized relationship with SEA.",
        ],
    },

    contact: {
        title: "Contact Information",
        content: [
            "If you have any questions, comments, or concerns regarding our Privacy Policy, Legal Disclaimer, and/or practices, please contact us:",
            "Company Name: sandip electronics  And Automation (SEA)",
            "Website: https://official.seaiot.in/",
            "Email: [Insert your official email, e.g., contact@seaiot.in]",
            "Address: [Insert your physical office address here]",
        ],
    },
}

const TermsOfUse = () => {
    const [activeSection, setActiveSection] = useState("introduction");

    const sectionRefs = useRef(
        Object.keys(policyData).reduce((acc, key) => {
            acc[key] = React.createRef();
            return acc;
        }, {})
    );

    const handleSidebarClick = (key) => {
        setActiveSection(key);

        const ref = sectionRefs.current[key];
        if (ref && ref.current) {
            ref.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    return (
        <div className="privacy-wrapper">
            {/* HERO */}
            <section className="hero-section">
                <h1>Terms of Use</h1>
                <p>sandip electronics  And Automation (SEA)</p>
                <p className="tou-hero-sub">
                    Please read these Terms carefully before using our website or submitting any form.
                </p>
            </section>

            {/* CONTENT */}
            <div className="privacy-content">
                <section className="content-section">
                    {/* LEFT SIDEBAR */}
                    <aside className="sidebar">
                        <ul>
                            <li
                                className={activeSection === "overview" ? "active" : ""}
                                onClick={() => handleSidebarClick("overview")}
                            >
                                Terms of Use
                            </li>
                            <li
                                className={activeSection === "acceptance" ? "active" : ""}
                                onClick={() => handleSidebarClick("acceptance")}
                            >
                                Acceptance of Terms
                            </li>
                            <li
                                className={activeSection === "consent" ? "active" : ""}
                                onClick={() => handleSidebarClick("consent")}
                            >
                                Handling of Personal Information
                            </li>
                            <li
                                className={activeSection === "personalInfo" ? "active" : ""}
                                onClick={() => handleSidebarClick("personalInfo")}
                            >
                                Use of Contact Information
                            </li>
                            <li
                                className={activeSection === "communications" ? "active" : ""}
                                onClick={() => handleSidebarClick("communications")}
                            >
                                Disclosure to Third Parties
                            </li>
                            <li
                                className={activeSection === "disclosure" ? "active" : ""}
                                onClick={() => handleSidebarClick("disclosure")}
                            >
                                Data Retention & Storage
                            </li>
                            <li
                                className={activeSection === "retention" ? "active" : ""}
                                onClick={() => handleSidebarClick("retention")}
                            >
                                Website Security and Risks
                            </li>
                            <li
                                className={activeSection === "security" ? "active" : ""}
                                onClick={() => handleSidebarClick("security")}
                            >
                                Cookies
                            </li>
                            <li
                                className={activeSection === "cookies" ? "active" : ""}
                                onClick={() => handleSidebarClick("cookies")}
                            >
                                User Responsibilities
                            </li>
                            <li
                                className={activeSection === "userObligations" ? "active" : ""}
                                onClick={() => handleSidebarClick("userObligations")}
                            >
                                Scope and Relationship to Legal Disclaimer
                            </li>
                            <li
                                className={activeSection === "scope" ? "active" : ""}
                                onClick={() => handleSidebarClick("scope")}
                            >
                                Contact Information
                            </li>
                            <li
                                className={activeSection === "contact" ? "active" : ""}
                                onClick={() => handleSidebarClick("contact")}
                            >
                                GDPR Data Protection Rights
                            </li>
                        </ul>
                    </aside>

                    {/* RIGHT CONTENT: show ALL sections */}
                    <main className="policy-content">
                        {Object.entries(policyData).map(([key, section]) => (
                            <section
                                key={key}
                                ref={sectionRefs.current[key]}
                                className="policy-section-block"
                            >
                                <h2>{section.title}</h2>

                                {section.content &&
                                    section.content.map((text, index) => (
                                        <p key={index}>{text}</p>
                                    ))}

                                {section.list && (
                                    <ul>
                                        {section.list.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                            </section>
                        ))}
                    </main>
                </section>
            </div>
        </div>
    );
};

export default TermsOfUse;
